/**
 * Help entry points that are not buttons: the user menu item ("Help for this
 * page", phone width included, where the top-bar ? is hidden) and the
 * `help.page` action the familiar skins' Help menus run. Mounted once by the shell.
 */
import { useNavigate } from '@tanstack/react-router';
import { useEffect, useRef } from 'react';
import { useAction } from '../../app/actions/registry.js';
import { useActiveRoute } from '../../app/layout/activeRoute.js';
import { registerUserMenuItem, useOptionalSession } from '../../app/shell.js';
import { helpTargetFor } from './targets.js';

export function HelpHost() {
  const session = useOptionalSession();
  const active = useActiveRoute();
  const navigate = useNavigate();
  const signedIn = session !== null && session !== undefined;
  const target = helpTargetFor(active?.moduleId, active?.route.path);
  const ref = useRef(target.href);
  ref.current = target.href;
  const open = () => void navigate({ to: ref.current as never });
  useEffect(() => {
    if (!signedIn) return undefined;
    return registerUserMenuItem({
      id: 'help.page',
      label: 'Help for this page',
      order: 45,
      onSelect: () => void navigate({ to: ref.current as never }),
    });
  }, [signedIn, navigate]);
  useAction('help.page', open, {
    label: 'Velora Help Center',
    icon: 'circle-help',
    enabled: signedIn,
  });
  return null;
}
